import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import { VehicleFirestoreService } from '../../services/vehicle.firestore.service';
import { VehicleActions } from './vehicle.action';
import { VehicleStateModel } from './vehicle.store';
import { FilterModel } from 'ag-grid-community';

@State<VehicleStateModel>({
  name: 'vehicles',
  defaults: {
    vehicles: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class VehicleState {
  private vehicleService = inject(VehicleFirestoreService);
  // private userState = inject(VehicleState);
  // private dbUser = inject(OrmService).vehicleCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(VehicleActions.GetAllVehicle)
  async getAllVehicless(ctx: StateContext<VehicleStateModel>) {
    ctx.patchState({ isLoading: true });
    const vehicless = await this.vehicleService.GetAll();
    ctx.patchState({
      vehicles: vehicless.map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(VehicleActions.UpdateVehicle)
  async updateVehicles(ctx: StateContext<VehicleStateModel>, { vehicleData, ref: id }: VehicleActions.UpdateVehicle) {
    await this.vehicleService.Update(id, vehicleData);
  }

  @Action(VehicleActions.PaginateQueryVehicle)
  async queryVehicles(
    ctx: StateContext<VehicleStateModel>,
    { request, isResetAfterFilterOrSort }: VehicleActions.PaginateQueryVehicle,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['userId']) {
    //   (request.filterModel as FilterModel)['userId']['values'] = (request.filterModel as FilterModel)[
    //     'userId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(VehicleState.users).find((user) => user.companyName === v)?.ref
    //   );
    // }
    // if (userId) {
    //   request.filterModel = {
    //     userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.vehicleService.SetQuery({
      ...request,
      count: state.vehicles.length,
      data: state.vehicles,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.vehicles.length;
      state.vehicles = [];
      state.vehicles.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.vehicles = [];
      state.vehicles.length = await this.vehicleService.GetBuildedCount(runs);
    }
    if (state.vehicles.length !== 0) {
      runs.push(...this.vehicleService.SetLimit({ ...request, count: state.vehicles.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const vehicless = await this.vehicleService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        vehicless.reverse().forEach(
          ({ data, ref }, i) =>
            (state.vehicles[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        vehicless.forEach(
          ({ data, ref }, i) =>
            (state.vehicles[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, vehicles: state.vehicles });
  }

  @Action(VehicleActions.VehicleError)
  vehiclesError(ctx: StateContext<VehicleStateModel>, { error }: VehicleActions.VehicleError) {
    console.error({ error });
    // await this.vehicleService.Update(id, vehiclesData);
  }

  @Action(VehicleActions.DeleteVehicles)
  async deletetVehicless(ctx: StateContext<VehicleStateModel>, { refs }: VehicleActions.DeleteVehicles) {
    await this.vehicleService.BatchDelete(refs);
  }

  @Action(VehicleActions.GetSumsCountOf)
  public async getCountOf(
    ctx: StateContext<VehicleStateModel>,
    { fields, timePeriod, filterModel }: VehicleActions.GetSumsCountOf,
  ) {
    const query = {
      filterModel: {},
      startRow: undefined,
      endRow: undefined,
      sortModel: [],
      data: [],
      count: 0,
    };
    if (timePeriod.dateFrom && timePeriod.dateTo) {
      (query.filterModel as FilterModel)['createdAt'] = {
        colId: 'createdAt',
        type: 'inRange',
        filter: timePeriod.dateFrom,
        filterTo: timePeriod.dateTo,
      };
    }
    // if (userId) {
    //   filterModel = { userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' }, ...filterModel };
    // }
    for (const [fieldKey, fieldFilter] of Object.entries(filterModel ?? {})) {
      (query.filterModel as FilterModel)[fieldKey] = fieldFilter;
    }
    (query.filterModel as FilterModel)['paymentResult'] = {
      colId: 'paymentResult',
      type: 'equals',
      filter: 'Successful',
    };

    // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
    const extraQuerry = this.vehicleService.SetQuery(query);
    const querrys: { [key: string]: { sum: number; count: number } } = {};
    for (const field of fields) {
      querrys[field.sumId] = {
        sum: await this.vehicleService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
        count: await this.vehicleService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
      };
    }
    ctx.patchState({ sums: querrys });
  }

  @Selector()
  static vehicles(state: VehicleStateModel) {
    return state.vehicles;
  }
  @Selector()
  static vehiclesCount(state: VehicleStateModel) {
    return state.vehicles.length;
  }

  @Selector()
  static sums(state: VehicleStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: VehicleStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static vehicleState(state: VehicleStateModel) {
    return state;
  }
}
